import { render, staticRenderFns } from "./dealRecord.vue?vue&type=template&id=1afe5103&scoped=true"
import script from "./dealRecord.vue?vue&type=script&lang=js"
export * from "./dealRecord.vue?vue&type=script&lang=js"
import style0 from "./dealRecord.vue?vue&type=style&index=0&id=1afe5103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe5103",
  null
  
)

export default component.exports